(function () {
  const root = window.Shopify?.routes?.root || '/';
  const kind = item => String(item.product_type || '').toLowerCase();
  const mattress = item => kind(item) === 'mattress';
  const furniture = item => mattress(item) || kind(item) === 'headboard';
  const swatch = item => String(item.product_id) === '15916904153462';
  const recycling = item => String(item.product_id) === '15853952336246';
  const assembly = item => String(item.product_id) === '15853952303478';
  function corrections(items) {
    const updates = {};
    let samples = 4, setup = items.some(furniture) ? 1 : 0;
    const capacity = new Map(items.filter(mattress).map(i => [i.key, i.quantity]));
    let unlinkedCapacity = [...capacity.values()].reduce((a, b) => a + b, 0);
    // Bound linked services first; a removed parent must never transfer its service to another mattress.
    for (const item of items.filter(i => recycling(i) && i.properties?._tms_parent)) {
      const parent = item.properties._tms_parent;
      const quantity = Math.min(item.quantity, capacity.get(parent) || 0);
      capacity.set(parent, (capacity.get(parent) || 0) - quantity);
      unlinkedCapacity -= quantity;
      if (quantity !== item.quantity) updates[item.key] = quantity;
    }
    for (const item of items) {
      let quantity = item.quantity;
      if (swatch(item)) { quantity = Math.min(quantity, samples); samples -= quantity; }
      if (assembly(item)) { quantity = Math.min(quantity, setup); setup -= quantity; }
      if (recycling(item) && !item.properties?._tms_parent) {
        quantity = Math.min(quantity, unlinkedCapacity); unlinkedCapacity -= quantity;
      }
      if (quantity !== item.quantity) updates[item.key] = quantity;
    }
    return updates;
  }
  async function getCart() {
    const response = await fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Your basket could not be checked. Please try again.');
    return response.json();
  }
  async function normalize(cart, sections = []) {
    const updates = corrections(cart.items);
    if (!Object.keys(updates).length) return cart;
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sections.slice(0, 5), sections_url: location.pathname })
    });
    const result = await response.json();
    if (!response.ok || result.errors) throw new Error('Your basket could not be updated. Please try again.');
    return result;
  }
  window.TMSCartRules = { corrections, getCart, normalize, mattress, furniture };
  // A final storefront check catches old baskets as well as changes made in another tab.
  // A checkout-validation app is still required to cover direct checkout/API requests.
  let checking = false;
  async function checkout(event) {
    const target = event.type === 'submit'
      ? (event.submitter?.name === 'checkout' ? event.submitter : null)
      : event.target.closest('a[href^="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!target) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const cart = await getCart();
      const changes = corrections(cart.items);
      if (Object.keys(changes).length) {
        await normalize(cart);
        sessionStorage.setItem('tms-cart-notice', 'Your basket has been updated: up to four free swatches, recycling with your mattress and one assembly service per delivery. Please review it before checkout.');
        location.assign(root + 'cart');
      } else location.assign(root + 'checkout');
    } catch (error) { alert(error.message); checking = false; }
  }
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  document.addEventListener('DOMContentLoaded', () => {
    const text = sessionStorage.getItem('tms-cart-notice');
    if (text && location.pathname.endsWith('/cart')) {
      const notice = document.createElement('p'); notice.setAttribute('role', 'status');
      notice.style.cssText = 'max-width:1100px;margin:20px auto;padding:16px;background:#f1eee7;color:#3f352c';
      notice.textContent = text; document.querySelector('main')?.prepend(notice);
      sessionStorage.removeItem('tms-cart-notice');
    }
  });
})();
